const viewRule = {
  name: 'COMPLIANCE_ACTION_ITEM',
  fields: {
    category: 'View Rule: ', // page
    action: 'open', //
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const viewSolutions = {
  name: 'COMPLIANCE_ACTION_ITEM',
  fields: {
    category: 'View Solutions: ', // page
    action: 'open', //
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const uploadEvidence = {
  name: 'COMPLIANCE_ACTION_ITEM',
  fields: {
    category: 'Upload Evidence: ', // page
    action: 'open', //
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const viewEvidence = {
  name: 'COMPLIANCE_ACTION_ITEM',
  fields: {
    category: 'View Evidence: ', // page
    action: 'open', //
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const viewAdvice = {
  name: 'COMPLIANCE_ACTION_ITEM',
  fields: {
    category: 'View Advice: ', // page
    action: 'open', //
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const viewHistory = {
  name: 'COMPLIANCE_ACTION_ITEM',
  fields: {
    category: 'View History: ', // page
    action: 'open', //
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const changeAssignee = {
  name: 'COMPLIANCE_DROPDOWN_CHANGE',
  fields: {
    category: 'Change Assignee: ', // page
    action: '', // new assignes|no assignee
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const changeStatus = {
  name: 'COMPLIANCE_DROPDOWN_CHANGE',
  fields: {
    category: 'Change Status: ', // page
    action: '', // new status
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const changeDate = {
  name: 'COMPLIANCE_DATE_CHANGE',
  fields: {
    category: 'Change Date: ', // page
    action: '', // new date
    label: '', // rule: question
    value: 0,
    nonInteraction: false
  }
}

const EVENTS = {
  VIEW_RULE: 'VIEW_RULE',
  VIEW_SOLUTIONS: 'VIEW_SOLUTIONS',
  UPLOAD_EVIDENCE: 'UPLOAD_EVIDENCE',
  VIEW_ADVICE: 'VIEW_ADVICE',
  VIEW_HISTORY: 'VIEW_HISTORY',
  CHANGE_STATUS: 'CHANGE_STATUS',
  CHANGE_ASSIGNEE: 'CHANGE_ASSIGNEE',
  VIEW_EVIDENCE: 'VIEW_EVIDENCE',
  CHANGE_DATE: 'CHANGE_DATE'
}

const EventModels = {
  VIEW_RULE: viewRule,
  VIEW_SOLUTIONS: viewSolutions,
  UPLOAD_EVIDENCE: uploadEvidence,
  VIEW_ADVICE: viewAdvice,
  VIEW_HISTORY: viewHistory,
  CHANGE_STATUS: changeStatus,
  CHANGE_ASSIGNEE: changeAssignee,
  VIEW_EVIDENCE: viewEvidence,
  CHANGE_DATE: changeDate
}

export default {
  EVENTS,
  EventModels
}



// WEBPACK FOOTER //
// ./src/analytics/Events/Compliance.js